import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import CustomerDetailsForm from '../CustomerManagementCustomerDetailsForm';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import * as Styles from './_customerManagementDeleteCustomerModal.module.scss';
import { TEditCustomerDetailsReduxParams } from '~types/feat/customer';

const CustomerManagementDeleteCustomerModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.customer.modals.deleteCustomerModalIsOpen);
    const getCustomerDetailsError = useAppSelector(state => state.customer.errors.getCustomerDetails);
    const gettingCustomerDetails = useAppSelector(state => state.customer.loadings.getCustomerDetails);
    const isLoading = useAppSelector(state => state.customer.loadings.deleteCustomer);
    const error = useAppSelector(state => state.customer.errors.deleteCustomer);
    const customerDetails = useAppSelector(state => state.customer.customerDetails);
    const allBranches = useAppSelector(state => state.branch.allBranches);

    const massagedCustomerDetails = {
        ...customerDetails,
        branchCode: allBranches.find(branch => branch.branchId === customerDetails.branchId)?.branchCode || '',
    };

    const handleModalOnClose = () => {
        dispatch(combinedActions.customerResetCustomerState());
        dispatch(combinedActions.customerSetDeleteCustomerModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditCustomerDetailsReduxParams) => dispatch(combinedActions.customerDeleteCustomerAttempt(data));

    return (
        <Modal
            title='Delete Customer'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {gettingCustomerDetails
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (
                    getCustomerDetailsError
                        ? (
                            <Text
                                isError
                                label={getCustomerDetailsError}
                            />
                        )
                        : (
                            <>
                                <CustomerDetailsForm
                                    submitButtonLabel='Delete'
                                    actionButtonIsLoading={isLoading}
                                    actionButtonClassName={Styles['action-button']}
                                    onSubmit={handleOnSubmit}
                                    inputIsDisabled={true}
                                    error={error}
                                    initialCustomerDetails={massagedCustomerDetails}
                                />
                            </>
                        )
                )
            }
        </Modal>
    );
};

export default CustomerManagementDeleteCustomerModal;
